import React from 'react';

import { Box, Grid, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/button';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

import Logo from '../../../static/images/logo.svg';

const EmailConfirmed = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box textAlign="center" pt={60 / 8}>
        <img src={Logo} alt="no-logo" />
        <Grid container alignItems="center" justifyContent="center">
          <Grid item md={4}>
            <Box
              bgcolor="#fff"
              borderRadius={3}
              mt={74 / 8}
              boxShadow="0px 0 10px rgba(0, 0, 0, 0.06)"
              padding="24px"
            >
              <Box
                width="64px"
                height="64px"
                bgcolor="#ECFDF3"
                mb={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ borderRadius: '50px' }}
              >
                <Box
                  width="50px"
                  height="50px"
                  bgcolor="#D1FADF"
                  sx={{ borderRadius: '50px' }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <TaskAltOutlinedIcon sx={{ color: '#039855' }} />
                </Box>
              </Box>
              <Stack alignItems="flex-start">
                <Box
                  component="h3"
                  mb={2.2}
                  className="m-0"
                  fontFamily="'Inter', sans-serif"
                >
                  Password Updated
                </Box>
                <Box
                  mb={2}
                  fontSize="14px"
                  color="#667085"
                  fontFamily="'Inter', sans-serif"
                >
                  You are now able to sign in with your new password.
                </Box>
              </Stack>
              <Stack pt={2} direction="row" justifyContent="end">
                <Button
                  variant="contained"
                  height="40px"
                  text="Back to sign in"
                  onClick={() => navigate('/')}
                />
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default EmailConfirmed;
